module.exports = __webpack_public_path__ + "ef070e6d502162ca6f2506e41631ca34.svg";